import { render } from "./DealerSelect.vue?vue&type=template&id=0f962c37"
import script from "./DealerSelect.vue?vue&type=script&lang=js"
export * from "./DealerSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Glenn\\Source\\GIT\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__